<template>
  <div class="modelcover">
    <div class="tips">
    	<div class="modal text-center">
    		<div class="text-right" style="cursor: pointer;">
    			<img src="../assets/img/closewin.png" @click="handleCloseTips" >
    		</div>
    		<img src="../assets/img/submtisuccess.png" >
    		<div class="" style="font-size: 24px;color: #4fa7ff;margin-top: 20px;">
    			问题提交成功
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {

      }
    },
    methods:{
        handleCloseTips(){
          this.$emit('closeTips')
        }
    }
  }
</script>

<style scoped>
  .modelcover {
    width: 100%;
        height: 100%;
        background-color: rgba(34, 34, 34, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        position: fixed;
        left: 0;
  }
  .modal {
  	width: 390px;
  	    height: 240px;
  	    border-radius: 10px;
  	    background-color: rgba(255, 255, 255, 1);
  	    position: relative;
  		padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/submitsuccess.vue